<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :class="[`${prefix}-icon`, `${prefix}-icon-psm-fuzhi`]" width="1em" height="1em" v-bind="$attrs"><defs><path id="svg_992a7608d8__a" d="M0 0L110 0 110 110 0 110z"/></defs><g transform="translate(10 10)" fill="none" fill-rule="evenodd"><mask id="svg_992a7608d8__b" :fill="useCurrentColor ? 'currentColor' : '#fff'"><use xlink:href="#svg_992a7608d8__a"/></mask><path d="M86.4281275,23.5711326 L110,23.5711326 L110,110 L23.5709518,110 L23.5709518,86.4279466 L0,86.4279466 L0,0 L86.4281275,0 L86.4281275,23.5711326 Z M86.4281275,39.2859116 L86.4281275,86.4279466 L39.2859938,86.4279466 L39.2859938,94.2859116 L94.2861089,94.2859116 L94.2861089,39.2859116 L86.4281275,39.2859116 Z M15.7141213,70.7140884 L70.7140062,70.7140884 L70.7140062,15.7140884 L15.7141213,15.7140884 L15.7141213,70.7140884 Z" :fill="useCurrentColor ? 'currentColor' : '#1BA8AF'" mask="url(#svg_992a7608d8__b)"/></g></svg>
</template>
<script>

export default {
  name: 'IconPsmFuzhi',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
